module.exports = __webpack_public_path__ + "static/media/icn-circle.6c29f0b7.svg";